// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2B14_"};